import type { AuthPanelDeck, AuthPanelDeckId } from '../types/auth-panel-deck';

/** Sign-up sells the product; sign-in welcomes back. */
export const AUTH_PANEL_DECKS: Record<AuthPanelDeckId, AuthPanelDeck> = {
  signUp: {
    id: 'signUp',
    label: 'What you can do with Clai',
    slides: [
      {
        id: 'meet-clai',
        eyebrow: 'The Deal AI Platform',
        title: 'One AI workspace for',
        rotatingWords: ['every deal', 'every signature', 'every payment'],
        caption:
          'Draft, sign, track and get paid in one place, set up in minutes.',
        visual: 'claiHub',
      },
      {
        id: 'create-contracts',
        eyebrow: 'Create contracts',
        title: 'Clai drafts your',
        rotatingWords: [
          'purchase agreements',
          'listing agreements',
          'seller disclosures',
        ],
        caption:
          'Describe what you need and get a compliant first draft from your own templates.',
        visual: 'create_contracts',
        chips: ['Filled from the deal', 'Matches your template'],
      },
      {
        id: 'esignatures',
        eyebrow: 'eSignatures',
        title: 'Collect signatures from',
        rotatingWords: ['buyers', 'sellers', 'tenants'],
        caption:
          'Send, sign, and track legally binding documents without leaving the platform.',
        visual: 'collect_esignatures',
        chips: ['Priya Patel signed', 'Reminder sent automatically'],
      },
      {
        id: 'compliance',
        eyebrow: 'Compliance',
        title: 'Stay compliant',
        rotatingWords: ['automatically', 'on every deal', 'without the chase'],
        caption:
          'Built-in checks and safeguards help you meet regulations without manual effort.',
        visual: 'compliance',
        chips: ['Missing form flagged', 'Audit trail saved'],
      },
      {
        id: 'payments',
        eyebrow: 'Payments',
        title: 'Get paid',
        rotatingWords: ['on time', 'securely', 'in one click'],
        caption:
          'Collect payments and hold funds securely until milestones are met.',
        visual: 'payments',
        chips: ['Earnest money received', 'Held until closing'],
      },
    ],
  },
  signIn: {
    id: 'signIn',
    label: 'What is waiting for you in Clai',
    slides: [
      {
        id: 'welcome-back',
        eyebrow: 'Welcome back',
        title: 'Your deals kept moving',
        rotatingWords: [
          'while you were away',
          'around the clock',
          'without the follow-ups',
        ],
        caption:
          'Clai tracked signatures, payments and deadlines so you can pick up where you left off.',
        visual: 'activityFeed',
      },
      {
        id: 'ask-clai',
        eyebrow: 'Clai AI',
        title: 'Ask Clai',
        rotatingWords: [
          'what needs you today',
          'about any deal',
          'to draft a follow-up',
        ],
        caption:
          'Get answers, summaries and drafts from everything in your workspace.',
        visual: 'askClai',
        chips: ['Answered from your deals', 'Draft ready to send'],
      },
      {
        id: 'deal-flow',
        eyebrow: 'Deal flow',
        title: 'From first hello',
        rotatingWords: ['to signed', 'to paid', 'to closed'],
        caption:
          'Every conversation, contract and payment stays together on the deal.',
        visual: 'conversation_to_close',
        chips: ['Contract sent for signature', 'Payment collected'],
      },
      {
        id: 'insights',
        eyebrow: 'Insights',
        title: 'Know what needs you',
        rotatingWords: ['today', 'this week', 'before it slips'],
        caption:
          'Renewals, deadlines and trends across your contracts, surfaced before they become problems.',
        visual: 'contract_insights',
        chips: ['Deadline in 2 days', 'Renewal reminder sent'],
      },
    ],
  },
};
